import { createFileRoute } from "@tanstack/react-router"

import AboutPage from "@/features/static/components/about"

export const Route = createFileRoute("/_screen/about")({
  component: About
})

function About() {
  return <AboutPage />
}
